mutation EntityTagDelete($entityTagDeleteInput: EntityTagDeleteInput!) {
  entityTagDelete(input: $entityTagDeleteInput) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}